import React from 'react';
import { Button } from '@shared/components';

interface SmriqConfirmedVehicleSummaryProps {
    className?: string;
    vrm?: string;
    currentMileage?: number;
    annualMileage?: number;
    onEdit: () => void;
}

/** Once the quote vehicle has been confirmed, this stands in for the form: a one-line recap of
 *  the confirmed reg/mileages (smaller than the title) and an Edit affordance to override them. */
export const SmriqConfirmedVehicleSummary: React.FC<SmriqConfirmedVehicleSummaryProps> = ({
    className,
    vrm,
    currentMileage,
    annualMileage,
    onEdit,
}) => {
    const recap = [
        vrm || null,
        currentMileage !== undefined ? `${currentMileage.toLocaleString()} miles` : null,
        annualMileage !== undefined ? `${annualMileage.toLocaleString()} miles/year` : null,
    ]
        .filter(Boolean)
        .join(' · ');

    return (
        <div
            className={`bg-mp-surface rounded-xl flex items-center justify-between gap-4 ${className ?? ''}`}
        >
            <div className="flex flex-wrap items-baseline gap-x-2">
                <h3 className="text-base font-semibold text-mp-foreground">Vehicle Details</h3>
                {recap && <span className="text-xs text-mp-muted">{recap}</span>}
            </div>
            <Button type="button" size="sm" variant="outline" onClick={onEdit}>
                Edit vehicle
            </Button>
        </div>
    );
};
